/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
// import { AnalyticsService } from './@core/utils/analytics.service';
import { GeneralService } from './services/general.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  API: any;

  public listarEntidad(){
    this.API.mostrarEntidad().subscribe(
        (success:any)=>{
            console.log(success);//el success contiene tu respuesta
        },
        (error)=>{
            console.log("algo ocurrio: ",error)
        }
   );
}
  // generalData: any;

  constructor(public _General: GeneralService) {}

  ngOnInit(): void {

    console.log("ole");
    
    // // OBTENEMOS LOS DATOS GENERICOS PARA EL USUARIO
    // this._General.onGeneralUpdated().subscribe((data) => {
    //   if (data == null) {
    //     this.generalData = [];
    //   }else {
    //     this.generalData = data;
    //   }
    // });
    // this.generalData = [];
    // this._General.getData();

    // DEFINIMOS UNA COOKIE GLOBAL CON EL TIMEZONE
  }

  
}




